function account() {
    return { 
        template : require('./account.wai.html') 
    };
};
export default account;


// WEBPACK FOOTER //
// ./src/login/account/account.wai.js